import { Injectable, signal, computed } from "@angular/core";
import { CurrencyService } from "./currency.service";

export enum Currency {
  BGN = 'BGN',
  EUR = 'EUR',
}

@Injectable({
  providedIn: 'root',
})
export class FxService {
  private readonly FIXED_RATE = 1.95583;

  readonly displayCurrency = signal<Currency | undefined>(undefined);

  constructor(
    public currencyService: CurrencyService
  ) {
    currencyService.defaultCurrency
      .subscribe(res => {
        this.setDisplayCurrency(Currency[res?.code as keyof typeof Currency]);
      });
  }

  readonly currencySymbol = computed(() =>
    this.displayCurrency() === Currency.EUR ? '€' : 'лв'
  );

  setDisplayCurrency(currency: Currency): void {
    this.displayCurrency.set(currency);
  }

  toggleCurrency(): void {
    const current = this.displayCurrency();
    this.displayCurrency.set(
      current === Currency.BGN ? Currency.EUR : Currency.BGN
    );
  }

  convert(amount: number, from: Currency, to: Currency): number {
    if (from === to) return amount;

    return from === Currency.BGN
      ? amount / this.FIXED_RATE
      : amount * this.FIXED_RATE;
  }

  toDisplay(amount: number, sourceCurrency: Currency = Currency.BGN): number {
    return this.convert(amount, sourceCurrency, this.displayCurrency()!);
  }

  format(amount: number, currency: Currency = this.displayCurrency()!): string {
    const symbol = currency === Currency.EUR ? '€' : 'лв';
    return `${amount.toFixed(2)} ${symbol}`;
  }
}